export const STREAM_UNREAD_MAX_RETRIES = 3
const STREAM_UNREAD_RETRY_BASE_DELAY_MS = 1500

export function getStreamUnreadRetryDelay(failureCount: number): number | null {
  if (failureCount < 1 || failureCount > STREAM_UNREAD_MAX_RETRIES) {
    return null
  }

  return STREAM_UNREAD_RETRY_BASE_DELAY_MS * failureCount
}
